import noop from 'lodash/noop';
import fuse from '../../_libs/redux-fusion';
import {CreateFormModalContainerHOC, UpdateFormModalContainerHOC} from '../../components/modals/FormModal';
import {ReactReduxModal} from '../../core-utilities/react-redux-modals';
import {ReduxRequestModal} from '../../core-utilities/redux-request-modal';
import {buildCreateRequest, buildUpdateRequest} from './requests';


export function buildCreateRequestModal(config) {
  const {
    prefix,
    getState,
    path,
    buildOnSave,
    modalOptions,
    modalComponent,
    logger,
  } = config;

  const reduxRequest = buildCreateRequest({
    prefix,
    getState: noop,
    path,
    logger,
  });

  const reduxModal = new ReactReduxModal({
    prefix,
    getState: noop,
    modalOptions,
    logger,
  });

  const requestModal = new ReduxRequestModal({
    getState,
    reduxRequest,
    reduxModal,
    logger,
  });

  const StreamedComponent = CreateFormModalContainerHOC({
    reduxRequest,
    getModalState: requestModal.getModalState,
    buildOnSave,
  });

  requestModal.setModal(fuse(StreamedComponent)(modalComponent));

  return {
    reduxRequest,
    reduxModal,
    requestModal,
  };
}

export function buildUpdateRequestModal(config) {
  const {
    prefix,
    getState,
    path,
    buildOnSave,
    modalOptions,
    modalComponent,
    logger,
  } = config;

  const reduxRequest = buildUpdateRequest({
    prefix,
    getState: noop,
    path,
    logger,
  });

  const reduxModal = new ReactReduxModal({
    prefix,
    getState: noop,
    modalOptions,
    logger,
  });

  const requestModal = new ReduxRequestModal({
    getState,
    reduxRequest,
    reduxModal,
    logger,
  });

  const StreamedComponent = UpdateFormModalContainerHOC({
    reduxRequest,
    getModalState: requestModal.getModalState,
    buildOnSave,
  });

  requestModal.setModal(fuse(StreamedComponent)(modalComponent));

  return {
    reduxRequest,
    reduxModal,
    requestModal,
  };
}



// WEBPACK FOOTER //
// ./src/js/config/redux-list/requestModals.js